 // 根据版本号，过滤出协议的名称
 export function filterAgreement(v, typeSource, versionsSource) {
     // 如果第二个参数是个数组， 默认当成第三个参数versions
     let type = Array.isArray(typeSource) ? '' : typeSource
     let versions = Array.isArray(typeSource) ? typeSource : versionsSource

     // 作为是否是全项进阶的标识
     const includesv6 = Array.isArray(versions) && (versions.includes('v6') || versions.includes('v6.1') || versions.includes('v6.2'))

     let vName = ''
     switch (v) {
         case 'special':
             vName = '您已开具增值税专用发票'
             break
         case 'v1':
         case 'v2':
         case 'v3':
         case 'v3-esl':
         case 'v3-201810':
             vName = 'VIPKID课程服务协议'
             break
         case 'v4':
             vName = '自然拼读精品课课程规则'
             break
         case 'v5':
         case 'v5.1':
         case 'v7':
             vName = 'VIPKID MC 主修课程 课程服务协议'
             break
         case 'v6':
         case 'v6.1':
         case 'v6.2':
             vName = 'VIPKID英语全项进阶课课程服务协议'
             break
         case 'exv1':
             vName = '课程卡用户须知'
             break
         case 'exv2':
             vName = '优美发音课用户须知'
             break
         case 'BAIDU_INSTALMENT':
             vName = '百度分期用户VIPKID课程服务补充协议'
             break
         case 'MUCFC_INSTALMENT':
             vName = includesv6 ? '招联分期补充协议-VIPKID英语全项进阶课' : '招联分期用户VIPKID课程服务补充协议'
             break
         case 'WEBANK_INSTALMENT':
             vName = includesv6 ? '微粒贷分期补充协议-VIPKID英语全项进阶课' : '微粒贷分期用户VIPKID课程服务补充协议'
             break
         case 'ALIPAYHB_INSTALMENT':
             vName = includesv6 ? '花呗分期补充协议-VIPKID英语全项进阶课' : '花呗分期用户VIPKID课程服务补充协议'
             break
         case 'ex-apple-pay':
             vName = '精品公开课课程规则'
             break
         case 'exChannel-v1':
             vName = '寒假冲刺包课程服务补充协议'
             break
         case 'exChannel-v2':
             vName = 'VIP专属一对一课程服务协议'
             break
         case 'ex-ipad':
         case 'ex-ipad-201901':
         case 'ex-gift-201902':
             vName = '赠品用户须知'
             break
         default:
             vName = ''
             break
     }
     // order list 
     if (v != 'special' && !type && vName) {
         vName = '《' + vName + '》'
     }
     // dialog 以及 收银台
     if (type && vName === 'VIPKID课程服务协议') {
         vName = 'VIPKID课程服务协议 VIPKID Course Service Agreement'
     }
     // 收银台使用。 加重
     if (type === 2 && ['BAIDU_INSTALMENT', 'MUCFC_INSTALMENT', 'WEBANK_INSTALMENT', 'ALIPAYHB_INSTALMENT'].includes(v)) {
         vName = '<b>' + vName + '</b>'
     }
     return vName
 }

 /**
  * 格式化日期方法
  * @param {时间戳} time 
  * @param {格式化方式} option  y/m/d/h/i/s/a: 年/月/日/时/分/秒/星期
  */
 export function formatTime(time, option) {
     if (arguments.length === 0) {
         return null
     }
     const format = option || 'y-m-d h:i:s'
     let date
     if (typeof time === 'object') {
         date = time
     } else {
         if (('' + time).length === 10) time = parseInt(time) * 1000
         date = new Date(time)
     }
     const formatObj = {
         y: date.getFullYear(),
         m: date.getMonth() + 1,
         d: date.getDate(),
         h: date.getHours(),
         i: date.getMinutes(),
         s: date.getSeconds(),
         a: date.getDay()
     }
     const time_str = format.replace(/(y|m|d|h|i|s|a)+/g, (result, key) => {
         let value = formatObj[key]
         if (key === 'a') {
             return '星期' + ['日', '一', '二', '三', '四', '五', '六'][value]
         }
         if (result.length > 0 && value < 10) {
             value = '0' + value
         }
         return value || 0
     })
     return time_str
 }